
import { useEffect, useState } from "react"
// import { FIREBASE_CONFIG } from "../../utils/utils"
//import AnonymousButton from "./anonymous-button"

// import "firebaseui/dist/firebaseui.css"
import "./choose-server.css"

// Extend the Window interface to include baseServerList
declare global {
  interface Window {
    baseServerList: any;
    // defaultServerUrl: string;
    // defaultServerId: string;
  }
}

export default function ChooseServer(props: {}) {

  let serverList = window.baseServerList;
  const serverListItem = useState(serverList);
  const currentServerUrl = localStorage.getItem("serverUrl");
  // console.log("serverList", serverList)
  // console.log("serverListItem", serverListItem)
  // console.log("currentServerUrl", currentServerUrl)
  useEffect(() => {
    // for循环每个服务器，拉取服务器的在线人数和系统版本
    for (let i = 0; i < serverListItem[0].length; i++) {
      try {

        const server = serverListItem[0][i];
        if (!server || !server.url) continue;
        fetch(`${server.url}/status`, { method: 'GET' })
          .then(response => response.json())
          .then(data => {
            // 假设返回的数据格式为 {"ccu":53,"maxCcu":1000,"version":"6.5.1"} 
            server.ccu = data.ccu;
            server.maxCcu = data.maxCcu;
            server.version = data.version;
            // console.log("server", server) 
            // 触发组件更新
            serverListItem[1]([...serverListItem[0]]);
            console.log("server", server)
          })
          .catch(error => {
            console.error('Error fetching server status:', error);
            if (!server) return;
            server.status = 'offline';
            serverListItem[1]([...serverListItem[0]]);
            console.log("server", server)
          });
      } catch (error) {
        console.error('Error parsing server status response:', error);
      }
    }
    // 默认先选择第一个服务器
    if (!currentServerUrl && serverListItem[0].length > 0) {
      localStorage.setItem('serverUrl', serverListItem[0][0].url);
      localStorage.setItem('serverVersion', serverListItem[0][0].version || '0.0.0');
    }
    return () => {
    };
  }, [])

  return (
    <div id="choose-panel" className=".choose-server">
      <div className="disclaimer">
        {/* <p>选择服务器:</p> */}
        {serverListItem[0]?.map((server: any) => (
          <div
            key={server.id}
            style={{  marginRight: '12px' }} // 横向排，每项右侧留点间距 display: 'inline-block'
          >
            <input
              type="radio"
              id={server.id}
              name="server"
              value={server.url}
              defaultChecked={server.url === currentServerUrl}
              onChange={() => {
                localStorage.setItem('serverUrl', server.url);
                localStorage.setItem('serverVersion', server.version || '0.0.0');
              }}
            />
            <label htmlFor={server.id} style={{ marginLeft: '4px' }}>
              {server.name}
              {server.ccu !== undefined ? (
                <span style={{ marginLeft: '6px', fontSize: '0.9em', color: 'white' }}>
                  (在线{server.ccu}人)
                  {server.version && (
                    <span style={{ marginLeft: '6px' }}>
                      【v{server.version}】
                    </span>
                  )}
                </span>
              ) : (
                <span style={{ marginLeft: '6px', fontSize: '0.9em', color: 'white' }}>
                  (离线)
                </span>
              )}
            </label>
          </div>
        ))}
      </div>

    </div>
  )
}